var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('store-cover-image'),_c('category-nav'),_c('product-list',{attrs:{"products":_vm.products,"loading":_vm.loading}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }